import { NgModule } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { JoinComponent } from './components/join/join.component';
import { AuthGuard } from './services/auth.guard';
import { FindIdComponent } from './components/find-id/find-id.component';
import { FindPwComponent } from './components/find-pw/find-pw.component';
import { ContentAddComponent } from './components/voc/content-add/content-add.component';
import { ContentDetailComponent } from './components/voc/content-detail/content-detail.component';
import { GuideComponent } from './components/guide/guide.component';
import { TermsComponent } from './components/terms/terms.component';
import { MobileLoginComponent } from './components/mobile/mobile-login/mobile-login.component';
import { OpenEventComponent } from './components/event/open-event/open-event.component';
import { MobileOpenEventComponent } from './components/event/mobile-open-event/mobile-open-event.component';
import { MobileJoinComponent } from './components/mobile/mobile-join/mobile-join.component';
import { MobileGuideComponent } from './components/mobile/mobile-guide/mobile-guide.component';
import { MobileFindIdComponent } from './components/mobile/mobile-find-id/mobile-find-id.component';
import { MobileFindPwComponent } from './components/mobile/mobile-find-pw/mobile-find-pw.component';
import { MobileMypageComponent } from './components/mobile/mobile-mypage/mobile-mypage.component';
import { MobileHistoryComponent } from './components/mobile/mobile-history/mobile-history.component';
import { MobileLinkComponent } from './components/mobile/mobile-link/mobile-link.component';
import { Event20250415Component } from './components/event/event20250415/event20250415.component';
import { MobileEvent20250415Component } from './components/event/mobile-event20250415/mobile-event20250415.component';

const routes: Routes = [
  { 
    path: '', 
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule)
  }
  ,{ path : 'login', component: LoginComponent}
  ,{ path : 'm/login', component: MobileLoginComponent}
  /* 종료
  ,{ path : 'openEvent', component: OpenEventComponent}
  ,{ path : 'm/openEvent', component: MobileOpenEventComponent}
  */
  ,{ path : 'pc/event', component: Event20250415Component}
  ,{ path : 'm/event', component: MobileEvent20250415Component}
  
  ,{ path : 'join', component: JoinComponent}
  ,{ path : 'm/join', component: MobileJoinComponent}
  ,{ path : 'guide', component: GuideComponent}
  ,{ path : 'm/guide', component: MobileGuideComponent}
  ,{ path : 'terms', component: TermsComponent}
  ,{ path : 'terms/:version', component: TermsComponent}
  ,{ path : 'find/id', component: FindIdComponent}
  ,{ path : 'find/pw', component: FindPwComponent}
  ,{ path : 'm/find/id', component: MobileFindIdComponent}
  ,{ path : 'm/find/pw', component: MobileFindPwComponent}
  ,{ path : 'm/mypage', canActivate: [AuthGuard], component: MobileMypageComponent}
  ,{ path : 'm/link', canActivate: [AuthGuard], component: MobileLinkComponent}
  ,{ path : 'm/account/history', canActivate: [AuthGuard], component: MobileHistoryComponent}
  ,{ path : 'find/pw/:userId/:tel/:otpCode', component: FindPwComponent}
  ,{ path : 'm/find/pw/:userId/:tel/:otpCode', component: MobileFindPwComponent}
  ,{ path : 'popup/voc/:masterId/add', component: ContentAddComponent}
  ,{ path : 'popup/voc/:masterId/:contentNo', component: ContentDetailComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { 
  mySubscription: any
  constructor(private router: Router, private activatedRoute: ActivatedRoute){
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });   
  }
}
